import React, { useEffect, useState, useContext } from "react";
// import './NavBar.css';
import { Link, useLocation, useNavigate } from "react-router-dom";
import userEvent from "@testing-library/user-event";
import {
  getSpiceBalance,
  getCategorys,
  getUserDetails,
} from "../Services/Service";
import { BottomSheetCustom } from "@cred/neopop-web/lib/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHouse,
  faCartShopping,
  faBarsStaggered,
  faArrowCircleDown,
  faArrowCircleLeft,
  faStore,
} from "@fortawesome/free-solid-svg-icons";
import UserContext from "../context/UserContext";
import BottomLogin from "./bottomLogin";
import DarkMode from "./DarkMode";
import GuidedTour from "./GuidedTour";
import ConfirmLogoutPopup from "../components/ConfirmLogoutPopup";

function NavBar({ Sidebar, isOpen, setIsopen }) {
  const [cateogoryImg, setCategoryImg] = useState([]);
  const { state, updateInfo, updateCartCount } = useContext(UserContext);
  const [user, setUser] = useState({
    firstName: "",
    lastName: "",
    mobile: "",
    email: "",
  });
  const location = useLocation();
  const [issOpen, setsOpen] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const [show, setShow] = useState(false);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const nav = useNavigate();
  // console.log(state)
  let formatter = Intl.NumberFormat("en-IN", { notation: "compact" });
  const handeClick = () => {
    let loggedInStatus = localStorage.getItem("auth")
      ? localStorage.getItem("auth")
      : 0;
    if (loggedInStatus === 0) {
      setsOpen(true);
    } else {
      if (document.querySelector(".content-apps")) {
        document.querySelector(".content-apps").scrollTo(0, 0);
      }
      return nav("/profile");
    }
  };
  const handeClickofMore = (e) => {
    e.preventDefault();
    let users = JSON.parse(sessionStorage.getItem("userInfo"));
    setUser({ ...user, ...users });
    setTimeout(() => {
      setsOpen(false);
      Sidebar();
    }, 0);
  };
  useEffect(() => {
    getCategorys()
      .then((resp) => {
        return resp.data.data;
      })
      .then((data) => setCategoryImg(data))
      .catch((err) => console.log(err.message));
    const userId = localStorage.getItem("auth");
    getUserDetails(userId)
      .then((res) => {
        setUser({ ...user, ...res.data.data });
      })
      .catch((err) => console.log(err.message));
    setTimeout(() => {
      updateCartCount();
      updateInfo();
    }, 0);
  }, []);

  useEffect(() => {
    let loggedInStatus = localStorage.getItem("auth")
      ? localStorage.getItem("auth")
      : 0;
    if (loggedInStatus) {
      setsOpen(false);
    }
  }, []);

  const handleLogoutClick = (e) => {
    e.preventDefault();
    const isLoggedIn = localStorage.getItem("auth");
    if (isLoggedIn) {
      // Close sidebar and show confirmation popup
      Sidebar();
      setShowLogoutConfirm(true);
    } else {
      // Not logged in, open login bottom sheet
      Sidebar();
      setTimeout(() => {
        setsOpen(true);
      }, 20);
    }
  };

  const handleLogoutConfirm = () => {
    // Perform logout
    let session = localStorage.getItem("sessionId");
    localStorage.removeItem("auth");
    setShowLogoutConfirm(false);
    nav(`/s/${session}`);
  };

  const handleLogoutCancel = () => {
    setShowLogoutConfirm(false);
  };

  return (
    <>
      {show && <GuidedTour />}
      <div className={`sidebar ${isOpen ? "active" : ""}`}>
        <div className="account">
          <div className="user_name d-flex justify-content-between align-items-center p-3 border-bottom">
            <h5 className="">
              {" "}
              {state.firstName === "" || state.firstName === "Ice"
                ? "IceSpice"
                : state.firstName}{" "}
              {state.lastName === "" || state.lastName === "Spice"
                ? "User"
                : state.lastName}
            </h5>{" "}
            <div onClick={Sidebar} style={{ cursor: "pointer" }}>
              {" "}
              {/* Added cursor style for better UX */}
              <FontAwesomeIcon icon={faArrowCircleLeft} />
            </div>
          </div>
          {/* This div will handle its own scrolling if content overflows */}
          <div className="side-links-scrollable">
            <div className="side-links">
              <Link
                to="/orders"
                onClick={() => {
                  Sidebar();
                  setTimeout(() => nav("/orders"), 20);
                }}
              >
                My Orders
              </Link>
              <Link
                to="/rewards-chakra"
                onClick={() => {
                  Sidebar();
                  setTimeout(() => nav("/rewards-chakra"), 20);
                }}
              >
                Rewards Chakra
              </Link>
              <Link
                to={`/refer?noCache=${Date.now()}`}
                onClick={() => {
                  Sidebar();
                  setTimeout(() => nav(`/refer?noCache=${Date.now()}`), 20);
                }}
              >
                Refer Friends
              </Link>
              {/* <Link
                to="/discounts"
                onClick={() => {
                  Sidebar();
                  setTimeout(() => nav("/discounts"), 20);
                }}
              >
                Discounts
              </Link> */}
              <Link
                to="/ledger"
                onClick={() => {
                  Sidebar();
                  setTimeout(() => nav("/ledger"), 20);
                }}
              >
                SpiceGold Transactions
              </Link>
              <Link
                to="/faq"
                onClick={() => {
                  Sidebar();
                  setTimeout(() => nav("/faq"), 20);
                }}
              >
                Support
              </Link>
              <Link
                to="/contact"
                onClick={() => {
                  Sidebar();
                  setTimeout(() => nav("/contact"), 20);
                }}
              >
                Contact Us
              </Link>
              <Link
                to="/home"
                onClick={() => {
                  Sidebar();
                  setTimeout(() => nav("/home"), 20);
                  setShow(true); // Assuming setShow is defined and used
                }}
              >
                Take a Tour
              </Link>
              <Link
                to="/privacy"
                onClick={() => {
                  Sidebar();
                  setTimeout(() => nav("/privacy"), 20);
                }}
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms"
                onClick={() => {
                  Sidebar();
                  setTimeout(() => nav("/terms"), 20);
                }}
              >
                Terms and Conditions
              </Link>
              {/* <Link
                to="/events"
                onClick={() => {
                  Sidebar();
                  setTimeout(() => nav("/events"), 20);
                }}
              >
                MVP Event
              </Link> */}
              <Link
                to="/aboutus"
                onClick={() => {
                  Sidebar();
                  setTimeout(() => nav("/aboutus"), 20);
                }}
              >
                About Us
              </Link>
              <Link
                to={localStorage.getItem("auth") ? "/Logout" : "/home"}
                onClick={handleLogoutClick}
              >
                {localStorage.getItem("auth") ? "Logout" : "Login"}
              </Link>
              <DarkMode Sidebar={Sidebar} /> {/* Assuming DarkMode component */}
            </div>
          </div>
        </div>
      </div>

      <div
        className={`sidebar-overlay ${isOpen == true ? "active" : ""}`}
        onClick={Sidebar}
      ></div>
      <ConfirmLogoutPopup
        isOpen={showLogoutConfirm}
        onConfirm={handleLogoutConfirm}
        onCancel={handleLogoutCancel}
      />
      {location.pathname !== "/auth-login" &&
        location.pathname !== "/penta" &&
        location.pathname !== "/csv" &&
        location.pathname.slice(0, 5) !== "/t&cp" &&
        location.pathname.slice(0, 2) !== "/s" && (
          <footer>
            <div className="container-sm">
              <div className="footer position-relative">
                <div className="row align-items-center align-items-lg-baseline">
                  <div className="col">
                    <Link
                      className="nav-link text-white text-center"
                      aria-current="page"
                      to="/home"
                    >
                      <svg
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="fas"
                        data-icon="house"
                        class="svg-inline--fa fa-house "
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 576 512"
                        style={{
                          color: "white",
                          width: "20px",
                          marginBottom: "5px",
                        }}
                      >
                        <path
                          fill="currentColor"
                          d="M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"
                        ></path>
                      </svg>{" "}
                      <br />
                      Home
                    </Link>
                  </div>
                  <div className="col">
                    <Link
                      className="nav-link text-white text-center"
                      aria-current="page"
                      to="/category"
                    >
                      <svg
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="fas"
                        data-icon="store"
                        class="svg-inline--fa fa-store "
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 576 512"
                        style={{
                          color: "white",
                          width: "20px",
                          marginBottom: "5px",
                        }}
                      >
                        <path
                          fill="currentColor"
                          d="M531.6 103.8L474.3 13.1C469.2 5 460.1 0 450.4 0H93.6C83.9 0 74.8 5 69.7 13.1L12.3 103.8c-29.6 46.8-3.4 111.9 51.9 119.4c4 .5 8.1 .8 12.1 .8c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.2 0 49.3-11.4 65.2-29c16 17.6 39.1 29 65.2 29c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4zM483.7 254.9l-.1 0c-5.3 .7-10.7 1.1-16.2 1.1c-12.4 0-24.3-1.9-35.4-5.3V384H112V250.6c-11.2 3.5-23.2 5.4-35.6 5.4c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3V384v64c0 35.3 28.7 64 64 64H432c35.3 0 64-28.7 64-64V384 252.6c-4 1-8 1.8-12.3 2.3z"
                        ></path>
                      </svg>{" "}
                      <br />
                      Category
                    </Link>
                  </div>
                  <BottomSheetCustom
                    open={issOpen}
                    handleClose={() => setsOpen(!issOpen)}
                    maxHeight="700px"
                  >
                    <BottomLogin onClose={() => setsOpen(!issOpen)} />
                  </BottomSheetCustom>
                  <div
                    className="col"
                    id="spiceGolds"
                    onClick={(e) => {
                      e.preventDefault();
                      handeClick();
                    }}
                  >
                    <Link className="align-items-center d-flex flex-column nav-link position-relative p-0 penta-login text-white">
                      <img
                        src="/assets/images/profilePicture1.jpg"
                        alt=""
                        className="login-img"
                      />
                      <br />
                      <div className="d-flex justify-content-center align-items-center bottom-spicegold">
                        <img
                          // src={spicegold} alt=""
                          style={{ height: "20px", width: "20px" }}
                          src={"/assets/images/spicegold.png"}
                          alt=""
                        />

                        <span>
                          {user.spicegold > 1000
                            ? `${formatter.format(state.spicegold)}`
                            : formatter.format(state.spicegold)}{" "}
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="col">
                    <Link
                      className="nav-link text-white text-center position-relative"
                      aria-current="page"
                      to="/cart"
                    >
                      <svg
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="fas"
                        data-icon="cart-shopping"
                        class="svg-inline--fa fa-cart-shopping "
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 576 512"
                        style={{
                          color: "white",
                          width: "20px",
                          marginBottom: "5px",
                        }}
                      >
                        <path
                          fill="currentColor"
                          d="M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
                        ></path>
                      </svg>
                      <br />
                      Cart
                      {state.cartCount > 0 && (
                        <span className="cart__count">{state.cartCount}</span>
                      )}
                    </Link>
                  </div>
                  <div className="col">
                    <Link
                      className="nav-link text-white text-center"
                      aria-current="page"
                      onClick={handeClickofMore}
                    >
                      <svg
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="fas"
                        data-icon="bars-staggered"
                        class="svg-inline--fa fa-bars-staggered "
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                        style={{
                          color: "white",
                          width: "20px",
                          marginBottom: "5px",
                        }}
                      >
                        <path
                          fill="currentColor"
                          d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM64 256c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
                        ></path>
                      </svg>{" "}
                      <br />
                      More
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </footer>
        )}
    </>
  );
}
export default NavBar;
